// src/components/Image.jsx
// Image split section: text + rotating image

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { palette, fonts } from "./theme";

// Images on the RIGHT pane
import image1 from "../assets/1.jpg";
import image2 from "../assets/2.jpg";
import image3 from "../assets/3.jpg";
import image4 from "../assets/4.jpg";
import image5 from "../assets/5.jpg";
import image6 from "../assets/6.JPG";
import image7 from "../assets/7.JPG";
import image8 from "../assets/8.JPG";
import image9 from "../assets/9.JPG";
import image10 from "../assets/10.JPG";

// South Indian temple craft background overlay
import templeOverlay from "../assets/temple-overlay.png";

const images = [image1, image2, image3, image4, image5,image6, image7, image8, image9, image10];

export default function ImageSplitHero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setIndex((prev) => (prev + 1) % images.length),
      5000
    );
    return () => clearInterval(id);
  }, []);

  return (
    <section className="relative overflow-hidden bg-cream">
      {/* temple pattern wash in the background */}
      <div
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage: `url(${templeOverlay})`,
          backgroundRepeat: "repeat",
          backgroundSize: "340px",
          mixBlendMode: "multiply",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <div className="relative z-10 py-12 md:py-10 px-6">
        <div className="mx-auto max-w-7xl grid md:grid-cols-2 gap-2 items-center">
          
          {/* LEFT TEXT BLOCK */}
          <div className="space-y-5 md:space-y-6">
            <p
              className="text-xs text-center uppercase tracking-[0.2em] text-sub"
              style={{ fontFamily: fonts.heading }}
            >
              Pure Veg · South Indian · Oakville
            </p>

            {/* FIX: prevent text cutting on mobile */}
            <p
              className="mt-10 text-center text-xm italic px-3"
              style={{ color: palette.sub, lineHeight: 1.5 }}
            >
              From crispy dosas and fluffy idlis to aromatic filter coffee,
              every dish at Carnatic Cafe is prepared just the way you would
              make it at home – with patience, love, and respect for tradition.
            </p>

            {/* ======================================================
                FINAL FIX: 3 Buttons Fit on ONE LINE (Mobile)
                ====================================================== */}
            <div className="flex gap-2 pt-2 justify-center flex-wrap md:flex-nowrap">

              <Link
                to="/menu"
                className="
                  inline-flex items-center justify-center
                  px-3 py-2
                  text-xs
                  rounded-full border border-sapphire text-cream
                  font-semibold transition hover:bg-orange
                  md:px-5 md:py-2.5 md:text-base
                  whitespace-nowrap
                "
              >
                View Menu
              </Link>

              <Link
                to="https://carnaticcafe.ezybite.com/"
                className="
                  inline-flex items-center justify-center
                  px-3 py-2
                  text-xs
      		  font-extrabold
                  rounded-full border border-sapphire text-sapphire
                  font-semibold transition hover:bg-orange
                  md:px-4 md:py-2.5 md:text-base
                  whitespace-nowrap
                "
  style={{
    backgroundColor: "#F97316",   // solid Carnatic gold
    color: "#000000",
boxShadow: "0 10px 28px rgba(0,0,0,0.3)"
  }}
              >
                Order Now
              </Link>

            </div>
          </div>

          {/* Rotating image */}
          <div
            className="relative w-full md:w-full min-h-[16rem] sm:min-h-[20rem] md:min-h-[26rem] 
                       rounded-2xl overflow-hidden shadow-lg border"
            style={{ borderColor: palette.railLine }}
          >
            <div
              className="absolute inset-0 transition-all duration-700 ease-in-out"
              style={{
                backgroundImage: `url(${images[index]})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#000",
                filter: "brightness(1.38)",
              }}
            />

            <div
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.05), rgba(0,0,0,0.35))",
              }}
            />
          </div>

        </div>
      </div>
    </section>
  );
}
